// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'drag';

export const Component = () => (
  <path
    fill='currentColor'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M6 4.714c0 .381.333.715.714.715a.732.732 0 0 0 .715-.715A.732.732 0 0 0 6.714 4 .732.732 0 0 0 6 4.714zm4.238 0c0 .381.333.715.714.715a.732.732 0 0 0 .715-.715.732.732 0 0 0-.715-.714.732.732 0 0 0-.714.714zM6 9c0 .38.333.714.714.714.381 0 .715-.333.715-.714s-.334-.714-.715-.714A.732.732 0 0 0 6 9zm4.238 0c0 .38.333.714.714.714.381 0 .715-.333.715-.714s-.286-.714-.715-.714a.732.732 0 0 0-.714.714zM6 13.286c0 .38.333.714.714.714a.732.732 0 0 0 .715-.714.732.732 0 0 0-.715-.715.732.732 0 0 0-.714.715zm4.238 0c0 .38.333.714.714.714a.732.732 0 0 0 .715-.714.732.732 0 0 0-.715-.715c-.38-.047-.714.334-.714.715z'
  />
);

export const viewBox = '0 0 18 18';
